<template>
  <!-- 直播订单详情 -->
  <div class="index-container">
    <div class="course-container">
      <div class="nav-box">
        首页 > 大健康人才培训 > 个人中心 > 我的课程
        <span>> 订单详情</span>
      </div>
      <personalSidebar>
        <div class="right-content">
          <div class="r-title">订单信息</div>
          <div class="detail-box">
            <div class="top-text">
              订单编号：{{detailInfo.order_sn}}
              <span>下单时间：{{detailInfo.create_time}}</span>
            </div>
            <div class="middle-box">
              <div
                class="img"
                :style="{ backgroundImage: 'url( ' + imgUrl + detailInfo['cover']+ ')' }"
              ></div>
              <div class="right-detail">
                <div class="d-time">开播时间：{{detailInfo.start_time}}</div>
                <div class="d-title">{{detailInfo.title}}</div>
                <div class="info-module">
                  <div
                    class="info-img"
                    :style="{ backgroundImage: 'url( ' + imgUrl + detailInfo['teacher_avatar']+ ')' }"
                  ></div>
                  <div class="info-name">{{detailInfo.teacher_name}}</div>
                  <div class="info-price">
                    总价：
                    <span>¥{{detailInfo.order_money}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="price-box">
              实付款：
              <span>¥</span>
              <span class="price">{{detailInfo.order_money}}</span>
              <template v-if="detailInfo.pay_type === 2">
                <i class="iconfont-icon icon-weixinfukuan"></i>
                <span class="pay-text">微信支付</span>
              </template>
              <template v-if="detailInfo.pay_type === 1">
                <i class="iconfont-icon icon-zhifubao"></i>
                <span class="pay-text">支付宝支付</span>
              </template>
              <template v-if="detailInfo.pay_type === 3">
                <i class="iconfont-icon icon-duigongzhuanzhang"></i>
                <span class="pay-text">对公打款</span>
              </template>
              <template v-if="detailInfo.pay_type === 4">
                <i class="iconfont-icon icon-xianjinzhifu"></i>
                <span class="pay-text">现金支付</span>
              </template>
            </div>
          </div>
        </div>
      </personalSidebar>
    </div>
  </div>
</template>
<script>
import personalSidebar from '../components/personalSidebar.vue';
import api from '../api/api';
import { imgUrl } from '../api/index';

export default {
  name: 'recordDetail',
  components: {
    personalSidebar
  },
  data() {
    return {
      detailId: '',
      imgUrl: imgUrl,
      detailInfo: {}
    };
  },
  mounted() {
    scrollTo(0, 0);
  },
  created() {
    const value = this.$route.query;
    console.log(value);
    if (value) {
      this.detailId = value.order_sn;
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      api.getRecordDetail({ order_sn: this.detailId }).then(res => {
        console.log(res);
        if (res.result) {
          this.detailInfo = res.result;
        } else {
          this.$message.warning(res.result.msg);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.course-container {
  // width: 72%;
  padding: 50PX 0;
  margin: 0 auto;
}
.nav-box {
  width: 72%;
  margin: 0 auto;
  font-size: 16PX;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.index-content {
  display: flex;
  justify-content: space-between;
  min-height: 976PX;
}
.right-content {
  width: 72%;
  padding: 32PX 46PX;
  background-color: #ffffff;
  .r-title {
    padding-bottom: 20PX;
    font-size: 20PX;
    font-weight: bold;
    border-bottom: 1PX solid #ececec;
  }
}
.detail-box {
  position: relative;
  padding: 24PX 0 12PX;
  margin-bottom: 36PX;
  border-bottom: 1PX solid #ececec;
  .top-text {
    padding-bottom: 18PX;
    color: #777777;
    span {
      padding-left: 30PX;
    }
  }
  .middle-box {
    display: flex;
    align-items: center;
  }
  .img {
    width: 30%;
    height: 188PX;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .right-detail {
    padding: 15PX 0 0 20PX;
  }
  .d-time {
    display: inline-flex;
    padding: 0 6PX;
    font-size: 12PX;
    color: #eca021;
    line-height: 20PX;
    background-color: rgba($color: #ffdca1, $alpha: 0.3);
    border-radius: 10PX;
  }
  .d-title {
    width: 68%;
    padding: 12PX 0 32PX;
    font-size: 18PX;
    font-weight: bold;
    line-height: 30PX;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .info-module {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #666666;
  }
  .info-img {
    width: 40PX;
    height: 40PX;
    margin-right: 14PX;
    background-color: sandybrown;
    border-radius: 50%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .info-name {
    flex: 1;
    color: #666666;
  }
  .info-price {
    color: #999999;
    span {
      color: #333333;
    }
  }
  .left-text {
    color: #777777;
    span {
      padding-left: 20PX;
    }
  }
  .price-box {
    text-align: right;
    color: #999999;
    span {
      color: #dd0707;
      font-weight: bold;
    }
    .price {
      font-size: 22PX;
    }
    .iconfont-icon {
      padding-left: 22PX;
      color: #6bcc03;
    }
    .icon-weixinfukuan {
      color: #6bcc03;
    }
    .icon-zhifubao {
      color: #189fe4;
    }
    .icon-duigongzhuanzhang {
      color: #faad14;
    }
    .icon-xianjinzhifu {
      color: #f8b551;
    }
    .pay-text {
      color: #333333;
      font-weight: normal;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/recordDetail.vue